module.exports = require('./getJSONGraph');



// WEBPACK FOOTER //
// ./lib/cache/get/jsonGraph/index.js